import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/features/auth';
import { FullPageSpinner } from '@/shared/ui/Spinner';

import { routes } from './route-paths';

export function PublicOnlyRoute() {
  const { status } = useAuth();

  if (status === 'checking') return <FullPageSpinner />;
  if (status === 'authenticated') return <Navigate to={routes.home} replace />;
  return <Outlet />;
}
